import {
    Directive,
        ElementRef,
        Input,
        AfterViewInit,
        Renderer2
} from '@angular/core';

@Directive({
    selector: '[appClampWithTail]'
})
export class ClampWithTailDirective implements AfterViewInit {
    @Input() lines = 4;
    private fullText = '';

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    ngAfterViewInit(): void {
        this.fullText = this.el.nativeElement.textContent.trim();
        requestAnimationFrame(() => {
            this.applyClamp();
        });
    }

    private applyClamp(): void {
        const element = this.el.nativeElement;
        const lineHeight = 18;
        const maxHeight = this.lines * lineHeight;

        element.textContent = this.fullText;

        if (element.scrollHeight <= maxHeight) {
            return;
        }

        this.renderer.setProperty(element, 'textContent', '');

        const topSpan = this.renderer.createElement('span');
        this.renderer.addClass(topSpan, 'clamp-top');
        this.renderer.setStyle(topSpan, '-webkit-line-clamp', (this.lines - 1).toString());
        this.renderer.setProperty(topSpan, 'textContent', this.fullText);

        const bottomSpan = this.renderer.createElement('span');
        this.renderer.addClass(bottomSpan, 'clamp-bottom');
        this.renderer.setProperty(bottomSpan, 'textContent', this.fullText);

        this.renderer.appendChild(element, topSpan);
        this.renderer.appendChild(element, bottomSpan);
    }
}
